/** 召回页共用的中文标签（召回管理、召回评测）；枚举的机器取值以后端画像为准，这里只管显示，没登记的原样显示。 */

/** 指南信息项条件的显示串：in ／ not_in ／ class ／ not_class ／ present（批 2：原「实体 reason 有 ／ 无」改挂成信息项已知 ／ 未知；
 * class 引用业务包取值表 info_values 里的类，如退货原因的质量类，取值在标签字典「信息项」看） */
export function slotCondText(c: {
	slot: string;
	in?: string[];
	not_in?: string[];
	class?: string;
	not_class?: string;
	present?: boolean;
}): string {
	if (c.in) return `${c.slot} ∈ ${c.in.join("、")}`;
	if (c.not_in) return `${c.slot} ∉ ${c.not_in.join("、")}`;
	if (c.class) return `${c.slot} 属于类 ${c.class}`;
	if (c.not_class) return `${c.slot} 不属于类 ${c.not_class}`;
	if (c.present !== undefined) return `${c.slot}${c.present ? "已知" : "未知"}`;
	return c.slot;
}

/** 业务对象与（旧画像 pv2 里的）实体类型的中文名；pv3 起原因、件数、金额、商品属性、问题、地址是信息项 */
export const ENTITY_LABEL: Record<string, string> = {
	order: "订单",
	line_item: "行项",
	product: "商品",
	product_attr: "商品属性",
	code: "优惠码",
	address: "地址",
	reason: "原因",
	quantity: "数量",
	amount: "金额",
	question: "问题原话",
};

export const STATE_LABEL: Record<string, string> = {
	no_orders: "名下无单",
	single_order: "名下一单",
	multi_orders: "名下多单",
	order_located: "订单已定位",
	order_ambiguous: "多单未定位",
	unshipped: "未发货",
	processed: "已处理（不能再改）",
	shipped: "已发货",
	delivered: "已签收",
	delivered_over_window: "签收超退货窗口",
	return_in_progress: "已在退货流程",
	refunded: "已退款",
	cancelled: "已取消",
	product_resolved: "商品已解析",
	product_not_found: "商品找不到",
	in_stock: "有货",
	out_of_stock: "缺货",
	discontinued: "停售",
	over_two_rounds: "超过两轮",
	last_unanswered: "上一轮没正面回答",
	need_clarify: "需要追问",
	handoff_this_turn: "本轮转人工",
	has_recommended: "已给出推荐",
};

export const METRIC_LABEL: Record<string, string> = {
	tool_recall: "工具召回率",
	tool_precision: "推荐档精准率",
	top1: "首位精准率",
	rec_hit: "推荐档召回率",
	avg_candidates: "平均候选数",
	avg_recommended: "平均推荐档数",
	cannot_do_hit: "无能办召回率",
	guide_recall: "指南召回率",
	guide_false_recall: "指南误召率",
};

export const ARM_LABEL: Record<string, string> = {
	baseline: "简单基线",
	coarse: "粗召回",
	rank: "排序（大模型）",
	jev: "排序（Jev，运行时默认）",
	jev_lingdt27b: "排序（蚂蚁 LingDT-27B，对比）",
	jev_lingdt: "排序（蚂蚁 LingDT，对比）",
};
export const ENTRY_LABEL: Record<string, string> = {
	all: "全量判断",
	prefilter: "粗筛留下",
	prerequisite: "作前置补进",
	standing: "常备",
};
export const FEED_LABEL: Record<string, string> = { gold: "金标喂入", chain: "串联喂入" };
export const SPLIT_LABEL: Record<string, string> = { "": "全部", dev: "开发集", holdout: "留出集" };

export function labelOf(map: Record<string, string>, key: string): string {
	return map[key] ?? key;
}

export function fmtRate(v: number | null | undefined): string {
	return v === null || v === undefined ? "—" : v.toFixed(3);
}
